import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonTriangleUp = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'triangle up icon'}</title>
      <polygon points='8,3 16,11 0,11' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
